// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapRightOutlinedSvg from "@ant-design/icons-svg/es/asn/SwapRightOutlined";
import AntdIcon from '../components/AntdIcon';

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapRightOutlinedSvg
  }));
};

SwapRightOutlined.displayName = 'SwapRightOutlined';
export default /*#__PURE__*/React.forwardRef(SwapRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js
// module id = 807
// module chunks = 0